import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GeneralServicesState } from "@/reducers/generalServices/generalServicesSlice";

export interface TenantSelfOnboardingResponse {
  caseNumber: string;
  caseId: string;
  tenantName: string;
  projectName: string;
  tawtheeqNumber: string;
  status: string;
  createdDate: string;
  CommunityManager: string[];
  tawtheeqDoc?: string;
  tawtheeqFileName?: string;
}

export interface TenantOnboardingState {
  activeStep: number;
  unitId: string;
  salesOrderId: string;
  tenantDetails: GeneralServicesState["serviceRequestDetails"] | null;
  selfOnboardingResponse: TenantSelfOnboardingResponse | null;
  showReceipt: boolean;
}

const MIN_STEP = 1;

const initialState: TenantOnboardingState = {
  activeStep: MIN_STEP,
  unitId: "",
  salesOrderId: "",
  tenantDetails: null,
  selfOnboardingResponse: null,
  showReceipt: false,
};

const tenantOnboardingSlice = createSlice({
  name: "tenantOnboarding",
  initialState,
  reducers: {
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    resetTenantOnboardingJourney: () => {
      return { ...initialState };
    },
    startTenantOnboardingJourney: (
      state,
      action: PayloadAction<Partial<Omit<TenantOnboardingState, "activeStep">>>
    ) => {
      return {
        ...state,
        activeStep: MIN_STEP,
        ...action.payload,
      };
    },
    setTenantDetails: (
      state,
      action: PayloadAction<GeneralServicesState["serviceRequestDetails"]>
    ) => {
      state.tenantDetails = action.payload;
    },

    setUnitId: (state, action: PayloadAction<string>) => {
      state.unitId = action.payload;
    },
    setSalesOrderId: (state, action: PayloadAction<string>) => {
      state.salesOrderId = action.payload;
    },
    setSelfOnboardingResponse: (
      state,
      action: PayloadAction<TenantSelfOnboardingResponse | null>
    ) => {
      state.selfOnboardingResponse = action.payload;
    },
    setShowReceipt: (state, action: PayloadAction<boolean>) => {
      state.showReceipt = action.payload;
    },
  },
});

export const {
  setActiveStep,
  resetTenantOnboardingJourney,
  startTenantOnboardingJourney,
  setTenantDetails,
  setUnitId,
  setSalesOrderId,
  setSelfOnboardingResponse,
  setShowReceipt,
} = tenantOnboardingSlice.actions;

export default tenantOnboardingSlice.reducer;
